<template>
  <el-dialog
    :title="title"
    :visible.sync="$parent.removeDialogStatus"
    class="del-dialog"
    @open="$parent.fontremoveenable = false"
  >
    <span slot="footer" class="dialog-footer btn-wrap">
      <el-button type="default" @click="$parent.removeDialogStatus = false">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click.stop="remove"
        :disabled="$parent.fontremoveenable"
        >{{ confirmtext }}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    confirmtext: {
      type: String,
      default: "确 定",
    },
  },
  methods: {
    remove() {
      this.$emit("remove");
    },
  },
};
</script>
